module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {}, _vm._l((_vm.data), function(store) {
    return _c('div', {
      staticClass: "store-card"
    }, [(store.id) ? [_c('div', {
      staticClass: "view-flex view-flex-middle"
    }, [_c('img', {
      staticClass: "store-logo",
      attrs: {
        "src": store.logo || 'https://fakeimg.pl/120x120/EFEFEF/CCC/?text=logo&font=lobster',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "store-name"
    }, [_vm._v(_vm._s(store.name))])]), _vm._v(" "), _c('div', {
      staticClass: "store-items"
    }, _vm._l((store.items), function(item, idx) {
      return (idx < 4) ? _c('div', {
        staticClass: "store-item"
      }, [_c('img', {
        staticClass: "store-item-thumb",
        attrs: {
          "src": item.imgUrl,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "store-item-amount"
      }, [_c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(item.price / 100))])])]) : _vm._e()
    }), 0)] : [_vm._m(1, true)]], 2)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "store-placeholder"
  }, [_c('div', {
    staticClass: "view-flex view-flex-middle"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "name"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "thumb"
  }), _vm._v(" "), _c('div', {
    staticClass: "price"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "thumb"
  }), _vm._v(" "), _c('div', {
    staticClass: "price"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "thumb"
  }), _vm._v(" "), _c('div', {
    staticClass: "price"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "thumb"
  }), _vm._v(" "), _c('div', {
    staticClass: "price"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d0a71ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d0a71ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/store.vue
// module id = 2578
// module chunks = 0